import { useEffect, useState } from 'react';
import NaverMap from './NaverMap';
import { FRONT_BASE_URL } from '../../api/axiosConfig';
import AddressSearchModal from '../common/modal/ModalComponents/AddressSearchModal';
import { AddressSearchResultType } from '../table/TableComponents/OrderAddressVerifyTable';
import styled from 'styled-components';
import SquareButton from '../button/SquareButton';
import { InputUnderline } from '../input/InputUnderline';

export interface AddressItem {
  address: string;
  clientName: string;
  longitude: number;
  latitude: number;
}

export interface NaverMapProps {
  addresses: AddressItem[];
  managerAddresses: AddressItem[];
}
export const NaverMapWrapper = () => {
  const [newCustName, setNewCustName] = useState<string>('');
  const [addressData, setAddressData] = useState<AddressItem[]>([]);
  const [ownAddressData, setOwnAddressData] = useState<AddressItem[]>([]);
  const [openModal, setOpenModal] = useState<boolean>(false);
  useEffect(() => {
    // 메시지를 수신할 리스너를 추가
    const handleMessage = (event: MessageEvent) => {
      // 출처를 확인 (보안을 위해 origin을 확인)
      if (event.origin !== FRONT_BASE_URL) {
        console.error('알 수 없는 출처의 메시지입니다.');
        return;
      }

      const messageData = event.data;
      console.log('messageData', messageData);
      if (messageData && messageData.message) {
        // 메시지에 대한 추가 처리
        const parsed: AddressItem[] = JSON.parse(messageData.message);
        setAddressData(parsed);
      }
    };

    window.addEventListener('message', handleMessage);

    // 클린업: 컴포넌트가 언마운트될 때 이벤트 리스너 제거
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  useEffect(() => {
    if (window.opener) {
      window.opener.postMessage(
        { type: 'MODAL_STATUS', openModal },
        window.origin
      );
    }
  }, [openModal]);

  function addNewMarker(data: AddressSearchResultType) {
    const newMarkerItem: AddressItem = {
      address: data.receiverAddress,
      longitude: data.longitude,
      latitude: data.latitude,
      clientName: newCustName,
    };
    setOwnAddressData((prev) => [...prev, newMarkerItem]);
    setOpenModal(false);
    setNewCustName('');
  }

  return (
    <div style={{ width: '100vw', height: '100vh', position: 'relative' }}>
      <AddMarkerArea className='even-shadow'>
        <InputUnderline
          value={newCustName}
          style={{ width: '230px' }}
          onChange={(text: string) => setNewCustName(text)}
          placeHolder='마커에 표시될 거래처명을 입력해주세요'
          placeHolderStyle={{ fontSize: '12px' }}
        />
        <Button
          onClick={() => newCustName.trim() !== '' && setOpenModal(true)}
          $active={newCustName.trim() !== ''}
        >
          마커 추가
        </Button>
      </AddMarkerArea>
      {openModal && (
        <AddressSearchModal
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onSelect={(data: AddressSearchResultType) => {
            addNewMarker(data);
          }}
        />
      )}
      <NaverMap addresses={[...addressData, ...ownAddressData]} />
    </div>
  );
};

const AddMarkerArea = styled.div`
  display: flex;
  padding: 2px 6px;
  flex-direction: row;
  align-items: center;
  height: 36px;
  background-color: white;
  gap: 15px;
  border-radius: 5px;
  position: absolute;
  top: 13px;
  left: 15px;
  z-index: 99;
`;

const Button = styled.div<{ $active: boolean }>`
  user-select: none;
  cursor: pointer;
  text-align: center;
  align-content: center;
  font-weight: 600;
  border-radius: 3px;
  font-size: 13px;
  width: 80px;
  height: 24px;
  background-color: ${({ $active }) => ($active ? '#ff8c88' : '#c5c5c5')};
  color: ${({ theme }) => theme.colors.white};
`;
